/* Cart page: keeps /cart in sync with the AJAX cart used by the drawer (cmc.js fires "cmc:cart" after a change),
   and saves the order note. Checkout itself is the native /cart form post. */
(function () {
  'use strict';
  if (window.__cmcCartPage) return;
  window.__cmcCartPage = true;
  var busy = false, again = false;

  function refresh() {
    var el = document.querySelector('[data-cart-page]');
    if (!el) return;
    if (busy) { again = true; return; }
    busy = true;
    fetch(location.pathname + '?section_id=' + encodeURIComponent(el.dataset.sectionId), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
        if (next) el.innerHTML = next.innerHTML;
      })
      .catch(function () { location.reload(); })
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }
  document.addEventListener('cmc:cart', refresh);

  var t;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    var v = e.target.value;
    clearTimeout(t);
    t = setTimeout(function () {
      fetch((window.CMC && CMC.root ? CMC.root : '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
    }, 500);
  });
})();
